var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 16858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 102",
    d: "M4.8067 12.0276H23.1925",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 103",
    d: "M4.8067 14.6538H23.1925",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1210",
    x: 2.18018,
    y: 23.2959,
    width: 14.4,
    height: 24,
    rx: 1.6,
    transform: "rotate(-90 2.18018 23.2959)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 478",
    cx: 19.43,
    cy: 18.1995,
    r: 1.31929,
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 479",
    cx: 21.2679,
    cy: 18.1995,
    r: 1.31929,
    stroke: "white",
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.db7d35a011c34c9a86817a217eaffc63.svg";
export { ForwardRef as ReactComponent };